<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getPickingSupplyForProductions"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="workOrderSupplys" optionsLabel="workOrderSupplyNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Supply" id="filter-" size="sm" :model.sync="filter.workOrderSupplyId" @input="getWorkOrderSupplys" @focus="getWorkOrderSupplys" />
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm" :model.sync="filter.documentStatusId" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
					<!-- <app-input-combobox-autocomplete :options="workOrderProcesss" optionsLabel="workOrderProcessNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Process" id="filter-" size="sm" :model.sync="filter.workOrderProcessId" @input="getWorkOrderProcesss" @focus="getWorkOrderProcesss" />
					<app-input-datetimepicker-range id="fieldset-work-order-supply-date" label-cols-sm="4" label-cols-lg="3" label="Work Order Supply Date" size="sm" :modelFrom.sync="filter.workOrderSupplyDateFrom" :modelTo.sync="filter.workOrderSupplyDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button /> -->
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line" id="filter-" size="sm" :model.sync="filter.lineId" @input="getLines" @focus="getLines" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getPickingSupplyForProductions"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Picking Supply For Production</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<!-- <b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/pickingsupplyforproduction/PickingSupplyForProduction.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay> -->

					</span>
					<!-- <Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal> -->
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<!-- <b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button> -->

					<b-overlay v-if="isShowDeleteButton && false"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-pickingsupplyforproduction" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="pickingSupplyForProductions" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="pickingSupplyForProductions.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Work Order Supply" class="table-filter">
					<v-select append-to-body label="workOrderSupplyNumber" :options="workOrderSupplys" :value="filter.workOrderSupplyId" :reduce="item => item.id" v-model="filter.workOrderSupplyId" :filterable="true" @input="getPickingSupplyForProductionsWithoutLoading" @search="getWorkOrderSupplys"></v-select>
				</b-th>
				<b-th stacked-heading="Line" class="table-filter">
					<v-select append-to-body label="code" :options="lines" :value="filter.lineId" :reduce="item => item.id" v-model="filter.lineId" :filterable="true" @input="getPickingSupplyForProductionsWithoutLoading" @search="getLines"></v-select>
				</b-th>
				<b-th stacked-heading="Document Status" class="table-filter">
					<v-select append-to-body label="name" :options="documentStatuss" :value="filter.documentStatusId" :reduce="item => item.id" v-model="filter.documentStatusId" :filterable="true" @input="getPickingSupplyForProductionsWithoutLoading" @search="getDocumentStatuss"></v-select>
				</b-th>
				<b-th></b-th>
				<!-- <b-th stacked-heading="Work Order Process" class="table-filter">
					<v-select append-to-body label="workOrderProcessNumber" :options="workOrderProcesss" :value="filter.workOrderProcessId" :reduce="item => item.id" v-model="filter.workOrderProcessId" :filterable="true" @input="getPickingSupplyForProductionsWithoutLoading" @search="getWorkOrderProcesss"></v-select>
				</b-th>
				<b-th stacked-heading="Work Order Supply Date" class="table-filter">
					<app-input-datetimepicker-range id="fieldset-work-order-supply-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Work Order Supply Date" size="sm" :modelFrom.sync="filter.workOrderSupplyDateFrom" :modelTo.sync="filter.workOrderSupplyDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getPickingSupplyForProductionsWithoutLoading" />
				</b-th>

				<b-th stacked-heading="Select All">
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
				</b-th> -->
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>

			<template v-slot:cell(workordersupply)="row">
				<a @click="() => ( $router.push({ name: 'pickingsupplyforproductionscan', params : { id: row.item.id } }))" class="a-link-detail">
					{{ row.item.workOrderSupply != null ? row.item.workOrderSupply.workOrderSupplyNumber : "" }}
					<!-- {{ row.item.workOrderSupply.workOrderSupplyDate != null && row.item.workOrderSupply.workOrderSupplyDate != "" ?
						(typeof row.item.productCode == 'string') ?
							row.item.workOrderSupply.workOrderSupplyDate.slice(0, 30) + (row.item.workOrderSupply.workOrderSupplyDate.length > 30 ? "..." : "" ) : row.item.workOrderSupply.workOrderSupplyDate : "" }} -->
				</a>
			</template>

			<template v-slot:cell(workOrderProcess)="row">
				{{ row.item.workOrderProcess != null ? row.item.workOrderProcess.workOrderProcessNumber : "" }}
			</template>
			<template v-slot:cell(workOrderSupplyDate)="row">
				{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY HH:mm") }}
			</template>
			<template v-slot:cell(line)="row">
				{{ row.item.line != null ? row.item.line.code : "" }}
			</template>
			<template v-slot:cell(documentStatus)="row">
				{{ row.item.documentStatusName }}
			</template>
			<template v-slot:cell(documentStatusBox)="row">
				<div :id="getDocumentStatus(row.item.documentStatusName)">
				</div>
			</template>

					<template v-slot:cell(front-action)="row">
						<!-- <div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div> -->
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-datetimepicker id="fieldset-work-order-supply-date" label-cols-lg="12"  label="Work Order Supply Date" size="sm" :model.sync="row.item.workOrderSupplyDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.documentStatusId" label="Document Status" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<!-- <div :id="getDocumentStatus(row.item.documentStatusName)">
						</div> -->
						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(pickingSupplyForProductionsPaging != null ? pickingSupplyForProductionsPaging.dataCount : 0)"
									:per-page="(pickingSupplyForProductionsPaging != null ? pickingSupplyForProductionsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-pickingsupplyforproduction.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-pickingsupplyforproduction.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-pickingsupplyforproduction.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }

	#box-green {
	width: 30px;
	height: 30px;
	background-color: green;
	}

	#box-yellow {
		width: 30px;
		height: 30px;
		background-color: yellow;
	}

	#box-red {
		width: 30px;
		height: 30px;
		background-color: red;
	}
</style>
<script>
import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import PickingSupplyForProductionList from '@/models/PickingSupplyForProduction/PickingSupplyForProductionList';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import LineFilter from '@/filters/Line/LineFilter';
import Line from '@/models/Line/Line';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import WorkOrderSupplyDetailFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyDetailFilter';
import WorkOrderSupplyDetail from '@/models/WorkOrderSupply/WorkOrderSupplyDetail';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		PickingSupplyForProduction, 
		PickingSupplyForProductionList, 
		PickingSupplyForProductionFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"workOrderSupply": {}, "class" : "th-work-order-supply first-child", "label" : "Work Order Supply Number", key: 'workOrderSupply', sortable: true}, 
				// {"workOrderProcess": {}, "class" : "th-work-order-process", "label" : "Work Order Process", key: 'workOrderProcess', sortable: true}, 
				// {"workOrderSupplyDate": {}, "class" : "th-work-order-supply-date last-child", "label" : "Work Order Supply Date", key: 'workOrderSupplyDate', sortable: true}, 
				{"line": {}, "class" : "th-line", "label" : "Line", key: 'line', sortable: true}, 
				{"documentStatus": {}, "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: true}, 
				{"documentStatusBox": {}, "class" : "th-document-status second-child", "label" : "Document Status", key: 'documentStatusBox', sortable: false}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			pickingSupplyForProductions: [],
			pickingSupplyForProductionsPaging: {},
			workOrderSupplys : [],
			workOrderProcesss : [],
			documentStatuss : [],
			lines : [],
			pickingSupplyForProductionDetails : [],
			pickingSupplyForProductionCases : [],
			pickingSupplyForProductionSuggestions : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
		}
	},	methods : {
		getDocumentStatus(status) {
			switch (status) {
				case 'OPEN':
					return 'box-red';
				case 'IN PROGRESS':
					return 'box-yellow';
				case 'CLOSED':
					return 'box-green';
				default: 
					return '';
			}
		},
		getPickingSupplyForProductions : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();

			if (this.sortBy != null && this.sortBy != undefined && this.sortBy != "") {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			this.filter["isDataFromLast7Days"] = false;
			this.sortingBy["statusdate"] = 1;

			if (!this.filter.workOrderProcessWorkOrderProcessNumber && !this.filter.lineId && !this.filter.documentStatusId) {
				this.filter["isDataFromLast7Days"] = true;
			}

			PickingSupplyForProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductions = result.data
					this.pickingSupplyForProductionsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPickingSupplyForProductionsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			this.filter["isDataFromLast7Days"] = false;
			this.sortingBy["statusdate"] = 1;

			if (!this.filter.workOrderProcessWorkOrderProcessNumber && !this.filter.lineId && !this.filter.documentStatusId) {
				this.filter["isDataFromLast7Days"] = true;
			}

			PickingSupplyForProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductions = result.data
					this.pickingSupplyForProductionsPaging = result
				}
			})
			.catch(error => {});
		},
		getWorkOrderSupplys : async function(input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			WorkOrderSupply.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplys = result.data
				}
			})
			.catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new PickingSupplyForProductionFilter();
			this.getPickingSupplyForProductions();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPickingSupplyForProductions();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PickingSupplyForProduction.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PickingSupplyForProduction.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			PickingSupplyForProduction.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			PickingSupplyForProduction.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'pickingsupplyforproductionedit';
						if(this.isScannerMode) {
							createRoute = 'pickingsupplyforproductionscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			PickingSupplyForProduction.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'pickingsupplyforproductionedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			PickingSupplyForProduction.deleteData(this, id).then(result => {
				if (result)
				{
					this.getPickingSupplyForProductions();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PickingSupplyForProduction.deleteMultipleData(this).then(result => {
					this.getPickingSupplyForProductions();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePickingSupplyForProductionParent = document.getElementById('table-list-pickingsupplyforproduction').parentNode;
			tablePickingSupplyForProductionParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePickingSupplyForProductionParent.scrollWidth - tablePickingSupplyForProductionParent.offsetWidth) == Math.ceil(tablePickingSupplyForProductionParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePickingSupplyForProductionParent = document.getElementById('table-list-pickingsupplyforproduction').parentNode;
			tablePickingSupplyForProductionParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePickingSupplyForProductionParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PickingSupplyForProductionFilter();
		this.getWorkOrderSupplys();
		// this.getWorkOrderProcesss()
		this.getDocumentStatuss();
		this.getLines();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Picking Supply For Production"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPickingSupplyForProductions();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getPickingSupplyForProductions();
			}
		},
		sortDesc: {
			handler: function() {
				this.getPickingSupplyForProductions();
			}
		},
		currentPage: {
			handler: function() {
				this.getPickingSupplyForProductions();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getPickingSupplyForProductions();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PickingSupplyForProduction.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "pickingsupplyforproductionindex") {
					this.getPickingSupplyForProductionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "picking_supply_for_production").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
